import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, filter } from 'rxjs/operators';
import { switchMap } from 'rxjs';
import { AppStore } from '@aaa/emember/store-types';
import { getAuthAccountDetails, isMembershipRequestStatus } from '@aaa/emember/store-membership';
import { RequestStatus } from '@aaa/emember/types';
import { Pages } from '../../../constants/pages';

export const waitForMembershipLoadGuard: CanActivateFn = () => {
  const store = inject(Store<AppStore>);
  const router = inject(Router);

  return store.select(isMembershipRequestStatus).pipe(
    filter((status) => [RequestStatus.SUCCESS, RequestStatus.FAILED].includes(status)),
    switchMap(() => store.select(getAuthAccountDetails).pipe(map((accountDetails) => !!accountDetails))),
    map((isReady) => {
      if (!isReady) {
        router.navigateByUrl(Pages.account);
        return false;
      }

      return true;
    }),
  );
};

export default waitForMembershipLoadGuard;
